import React, {Component} from 'react';

export default class Submit extends Component {
    render() {
        return <button type={'submit'}>{this.props.title}</button>
    }
}